import navigation from "@/lang/pl/navigation";
import generics from "@/lang/pl/generics";
import questions from "@/lang/pl/questions";
import a11y from "@/lang/pl/a11y";
import velt from "@/lang/pl/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
